import styled from 'styled-components';
import {menuBarHeight} from 'components/Header/MenuBar/styles';

export const HeaderWrapper = styled.div`
  margin-bottom: ${menuBarHeight}px;
  background: #ffffff;
`;
